<template>
  <div id="app">
    <el-config-provider :message="{ max: 3 }"> </el-config-provider>
    <router-view></router-view>
  </div>
</template>

<script>
import websocket from "@/utils/websocket";
export default {
  name: "app",
  components: {},
  data() {
    return {};
  },
  mounted(){
    // websocket.initWebsocket();
    // window.addEventListener("beforeunload", websocket.websocketOut);
  },
  unmounted() {
    // window.removeEventListener("beforeunload", websocket.websocketOut);
  },
  methods: {
    
  },
};
</script>

<style lang="scss">
@import "@/assets/css/app.scss";
</style>
